
import { Component, Vue } from 'vue-property-decorator'
import Channel from '@/components/channels/Channel.vue'

@Component({
  components: {
    Channel
  }
})
export default class ChatboxWrapper extends Vue {
  private params = {
    httpUrl: process.env.VUE_APP_BACKEND_URL,
    uploadUrl: process.env.VUE_APP_UPLOAD_URL,
    uploadSize: parseInt(process.env.VUE_APP_UPLOAD_MAX_SIZE, 10),
    windowUrl: process.env.VUE_APP_WINDOW_URL,
    wsUrl: process.env.VUE_APP_BACKEND_WS
  }

  get channel () {
    return Object.assign({}, this.webchat, { name: 'chatbox' })
  }

  get webchat () {
    return this.$store.getters.channels[0]
  }

  created () {
    document.title = `${this.webchat.settings.name} - ${this.webchat.settings.punchline}`
  }
}
